/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TutorApproval_tutor = {|
  +id: string;
  +approvals: $ReadOnlyArray<{|
    +approved: ?boolean;
    +subjectGradeId: string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TutorApproval_tutor",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorDocuments_tutor",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorSubjectGrades_tutor",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TutorApproval",
      "name": "approvals",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "approved",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "subjectGradeId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Tutor"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/__generated__/TutorApproval_tutor.graphql.js